
import React, { useContext } from 'react'
import { Button } from 'browser/components/atomic-elements/atoms/button/button'
import apis from 'browser/app/models/apis'
import { InternalViewContext } from 'browser/contexts/internal-view/internal-view-context'
import './_impersonation-banner.scss'

export const ImpersonationBanner: React.FC = () => {
  const { showInternals, setShowInternals } = useContext(InternalViewContext)

  if (!apis.getSettings().isImpersonating()) {
    return null
  }

  const stopImpersonating = () => {
    apis.stopImpersonation().then(() => {
      window.location.reload()
    })
  }

  return (
    <div className="c-impersonation-banner">
      You are currently impersonating another user.
      {!apis.getSettings().isAdmin && (
        <Button
          buttonText={showInternals ? 'Hide superadmin views' : 'Show superadmin views'}
          onClick={() => setShowInternals(!showInternals)}
        />
      )}
      <Button buttonText="Stop Impersonating" onClick={stopImpersonating} />
    </div>
  )
}
